var _defs, _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "in-progress-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.221,
    height: 26.221,
    viewBox: "0 0 26.221 26.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.386,
    x2: 0.967,
    y2: 0.563,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39d6a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d5842"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11904",
    "data-name": "Path 11904",
    className: "cls-1",
    d: "M12.588,2h-.874l.219,2.185h1.42a8.754,8.754,0,0,1-.109,17.48H11.933l-.109,2.185h1.857A10.98,10.98,0,0,0,23.841,12.488,10.957,10.957,0,0,0,13.681,2.109h-.546A.985.985,0,0,0,12.588,2Zm-3.824.765c-.546.328-1.093.546-1.639.874L8.327,5.5a11.917,11.917,0,0,1,1.2-.656ZM4.722,5.715A12.366,12.366,0,0,0,3.63,7.135L5.487,8.227c.219-.328.546-.656.874-1.093ZM16.631,8.992l-5.026,5.681-2.95-2.294-1.2,1.857,4.589,3.5,6.337-7.211Zm-14.2.656A4.948,4.948,0,0,0,2.1,11.4l2.185.328a6.672,6.672,0,0,1,.328-1.42Zm1.857,4.37L2.1,14.236v.328c.109.437.219.983.328,1.42L4.5,15.329a3.928,3.928,0,0,1-.219-1.2Zm1.2,3.5-1.857,1.2a7.014,7.014,0,0,0,1.093,1.42l1.639-1.42A8.338,8.338,0,0,1,5.487,17.514Zm2.841,2.841-1.2,1.857c.546.328,1.093.546,1.639.874l.874-1.967C9.092,20.792,8.655,20.573,8.327,20.354Z",
    transform: "translate(0.194 0.185)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2492",
    "data-name": "Rectangle 2492",
    className: "cls-2",
    width: 26.221,
    height: 26.221
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.5fc58b1b5e8ad3d80d75f0590ba1138a.svg";
export { ForwardRef as ReactComponent };